import { Create, Edit, SimpleForm, SelectInput, TextInput, required, useTranslate } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';

const Fields = () => {
  const translate = useTranslate();
  return (
    <>
      <TextInput source="field_name" validate={required()} />
      <SelectInput
        source="type"
        validate={required()}
        choices={['text', 'email', 'phone', 'number'].map((type) => ({
          id: type,
          name: translate(`resources.qrUserDetails.types.${type}`, { _: type }),
        }))}
      />
    </>
  );
};

export const CallerFieldCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="qrUserDetails" />}>
      <MyFormContainer>
        <Fields />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export const CallerFieldEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="qrUserDetails" />}>
      <MyFormContainer>
        <Fields />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);
